class FindInStoreDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#FindInStoreDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderFindInStoreIconAccessibility();
  }

  setHeaderFindInStoreIconAccessibility() {
    const findInStoreLink = document.querySelector('#find-in-store-trigger');
    findInStoreLink.setAttribute('role', 'button');
    findInStoreLink.setAttribute('aria-haspopup', 'dialog');
    findInStoreLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(findInStoreLink)
    });
    findInStoreLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(findInStoreLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('FindInStoreDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderInventoryInfo(currentVariant) {
    if (!currentVariant) return;
    
    fetch(`${this.dataset.url}?variant=${currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        
        const destination = document.getElementById(`${this.dataset.section}`).querySelector('.drawer__body');
        const source = html.getElementById(`${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`).querySelector('.drawer__body');
        if (source && destination) destination.innerHTML = source.innerHTML;
      });
  }

  // getSectionInnerHTML(html, selector = '.shopify-section') {
  //   return new DOMParser()
  //     .parseFromString(html, 'text/html')
  //     .querySelector(selector).innerHTML;
  // }

  // getSectionsToRender() {
  //   return [
  //     {
  //       id: 'find-in-store-drawer',
  //       selector: '#FindInStoreDrawer'
  //     },
  //     {
  //       id: 'find-in-store-trigger'
  //     }
  //   ];
  // }

  // getSectionDOM(html, selector = '.shopify-section') {
  //   return new DOMParser()
  //     .parseFromString(html, 'text/html')
  //     .querySelector(selector);
  // }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('find-in-store-drawer', FindInStoreDrawer);